import React from 'react'
// libs
import moment from 'moment'
import { useQuery } from '@apollo/client/react'
// components
import { Table } from 'components/UI'
import TableRow from '@mui/material/TableRow'
import PageLoader from 'components/UI/Loader/PageLoader'
import ActionsMenu from './components/ActionMenu'
import InjuryMasterRevokeModal from 'components/Modals/InjuryMasterRevokeModal'
// constants
import { ENVIRONMENT_OPTIONS } from 'components/Modals/InjuryMasterSettingsModal/constants'
// views
import { TableCell } from 'themes/views/tables'
// types
import { IInjuryMasterSettings } from 'types/graphql'
// graphql
import { INJURY_MASTER_SETTINGS_QUERY } from 'graphql/injuryMaster/queries'

const headers = [
  { id: 'accountId', left: true, label: 'ACCOUNT ID' },
  { id: 'environment', left: true, label: 'ENVIRONMENT' },
  { id: 'updatedAt', left: true, label: 'LAST UPDATED' },
  { id: 'actions', left: true }
]

const noop = () => {}

const formatDate = (value?: string | null) => (value ? moment(value).format('DD/MM/YYYY [at] h:mma') : '—')

const InjuryMasterTable: React.FC = () => {
  const { data, loading, networkStatus } = useQuery<{ injuryMasterSettings: IInjuryMasterSettings }>(
    INJURY_MASTER_SETTINGS_QUERY
  )

  const isLoading = loading || networkStatus === 1

  const settings = data?.injuryMasterSettings
  const rows = settings ? [settings] : []

  if (isLoading) {
    return <PageLoader isLoading />
  }

  return (
    <>
      <Table
        page={0}
        perPage={20}
        headers={headers}
        totalCount={rows.length}
        data={rows}
        onPageChange={noop}
        onPerPageChange={noop}>
        {({ data }) =>
          data.map((item) => (
            <TableRow key={item.accountId} hover data-testid='injury-master-settings-row'>
              <TableCell>{item.accountId}</TableCell>
              <TableCell>{ENVIRONMENT_OPTIONS.find(({ value }) => value === item.environment)?.label ?? '—'}</TableCell>
              <TableCell>{formatDate(item.updatedAt)}</TableCell>
              <ActionsMenu settings={item} />
            </TableRow>
          ))
        }
      </Table>

      <InjuryMasterRevokeModal />
    </>
  )
}

export default InjuryMasterTable
